// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!components/ui/common.module.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._5008b6{--list-gutter: var(--spacer);display:grid;gap:var(--list-gutter);align-items:start}._5008b6>*{margin-top:0}._5008b6>._0e51de:not(:first-child),._5008b6>*+h4,._5008b6>*+h5,._5008b6>*+h6{margin-top:var(--spacer)}._582694{--list-gutter: 0.3125rem}._450f54{--list-gutter: 1rem}._2f42a2{--list-gutter: var(--medium-spacer)}._3e09e5{--list-gutter: 0;border-radius:.5rem;background:var(--white)}._3e09e5>*{padding:.75em 1em}._3e09e5>*+*{border-top:1px solid var(--subtle)}.e8ba9f{font-weight:600}.afae1e{list-style:disc;padding-left:1.25em;display:grid;gap:.5em}.f227db{gap:2px;font-weight:500;font-size:.875em}.f227db a{padding:1em}.f227db a:not(.active):hover{border-radius:.25em;background:rgba(0,0,0,.05)}.f227db .active{background:linear-gradient(90deg, var(--secondary) 3px, transparent 3px) !important;font-weight:bold}._672ef6{--list-gutter: 2px}._672ef6>:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}._672ef6>:not(:last-child){border-bottom-left-radius:0;border-bottom-right-radius:0}", ""]);
// Exports
exports.locals = {
	"list": "_5008b6 " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["spacing"] + "",
	"title": "_0e51de",
	"tiny-gutter": "_582694",
	"tinyGutter": "_582694",
	"small-gutter": "_450f54",
	"smallGutter": "_450f54",
	"medium-gutter": "_2f42a2",
	"mediumGutter": "_2f42a2",
	"bordered": "_3e09e5",
	"bold": "e8ba9f",
	"bullet-list": "afae1e " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["spacing"] + "",
	"bulletList": "afae1e " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["spacing"] + "",
	"link-list": "f227db",
	"linkList": "f227db",
	"group": "_672ef6"
};
module.exports = exports;
